import Reporting from './Reporting';

export { Reporting };



// WEBPACK FOOTER //
// src/modules/screens/reporting/Reporting/components/index.js